import React from "react";

class StepProgress extends React.Component {
  render() {
    const { steps, currentStep, info } = this.props;

    return (
      <div className="flex items-center gap-2">
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const isActive = currentStep === stepNumber;
          const isCompleted = currentStep > stepNumber;

          return (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center">
                <div
                  className={`relative flex h-8 w-8 items-center justify-center rounded-full border-2 font-semibold ${
                    isActive && "border-blue-500 bg-blue-500 text-white"
                  } ${
                    !isActive &&
                    (isCompleted
                      ? "border-gray-500 bg-gray-500 text-white"
                      : "border-gray-300 bg-white text-gray-600")
                  }`}
                >
                  {stepNumber}
                  <div
                    className={`absolute w-56 text-center ${
                      isActive && "text-blue-600"
                    } ${
                      !isActive &&
                      (isCompleted ? "text-gray-600" : "text-gray-500")
                    }`}
                    style={{
                      top: "2rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    {label}
                  </div>
                  {info && info[index] && (
                    <div
                      className="absolute w-56 break-all text-center text-xs leading-none text-gray-600"
                      style={{
                        top: "3.4rem",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      {info[index]}
                    </div>
                  )}
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="h-1 flex-1 bg-gray-300"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}
export default StepProgress;
